import React from 'react'
import { useLocation } from 'react-router-dom'
import SEO from './SEO'
import seoManifest from '../seo/seo-manifest.json'

function normalizePath(path) {
  if (!path) return '/'
  // strip trailing slash except root
  if (path !== '/' && path.endsWith('/')) path = path.slice(0, -1)
  return path
}

export default function ManifestSEO() {
  const location = useLocation()
  const raw = normalizePath(location.pathname)

  // Try exact match first
  let entry = seoManifest[raw]

  // Dynamic category pages mapping
  if (!entry && raw.startsWith('/category')) {
    entry = seoManifest['/category-page']
  }

  // Fallbacks: try a relaxed key (remove non-alphanumeric)
  if (!entry) {
    const relaxed = raw.replace(/[^a-z0-9\-\/]/gi, '')
    entry = seoManifest[relaxed]
  }

  // Final fallback to homepage metadata
  if (!entry) entry = seoManifest['/'] || {}

  // Convert manifest fields into props expected by SEO component
  const { title, description, canonical, image, keywords, noIndex } = entry

  // keywords in manifest may be a comma-separated string
  const kw = typeof keywords === 'string' && keywords.trim() ? keywords.split(',').map(k => k.trim()) : keywords

  return <SEO title={title} description={description} canonical={canonical} image={image} keywords={kw} noIndex={noIndex} />
}
